import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BooksIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M8.1006 1.5H6.56607C5.9782 1.5 5.5 1.9782 5.5 2.56607V13.4342C5.5 14.0221 5.9782 14.4999 6.56607 14.4999H8.1006C8.68813 14.4999 9.16667 14.0221 9.16667 13.4342V2.56607C9.16667 1.9782 8.68813 1.5 8.1006 1.5ZM8.16667 13.4343C8.16667 13.4707 8.13707 13.5 8.1006 13.5H6.56607C6.5296 13.5 6.5 13.4707 6.5 13.4343V2.56607C6.5 2.5296 6.5296 2.5 6.56607 2.5H8.1006C8.13707 2.5 8.16667 2.5296 8.16667 2.56607V13.4343Z"
        fill={color}
      />
      <path
        d="M15.5071 12.8713L13.4381 3.54021C13.3763 3.26221 13.2103 3.02494 12.9701 2.87194C12.7299 2.71894 12.4447 2.67074 12.1667 2.73034L10.6686 3.06234C10.0957 3.18961 9.73173 3.75961 9.85806 4.33414L11.9271 13.6655C12.0377 14.1616 12.4791 14.5002 12.9681 14.5002C13.0443 14.5002 13.1211 14.4917 13.1985 14.4748L14.6966 14.1428C14.9746 14.0809 15.2122 13.9149 15.3652 13.6747C15.5182 13.4345 15.569 13.1493 15.5071 12.8713ZM14.4805 13.1662L12.9824 13.4982C12.9427 13.5079 12.9108 13.4839 12.9036 13.4487L10.8346 4.11868C10.8268 4.08254 10.8496 4.04674 10.8847 4.03894L12.3828 3.70694C12.4225 3.69654 12.4537 3.72161 12.4616 3.75708L14.5306 13.0875C14.5377 13.1181 14.5104 13.1597 14.4805 13.1662Z"
        fill={color}
      />
      <path
        d="M3.43397 1.5H1.89944C1.31157 1.5 0.833374 1.9782 0.833374 2.56607V13.4342C0.833374 14.0221 1.31157 14.4999 1.89944 14.4999H3.43397C4.02184 14.4999 4.50004 14.0221 4.50004 13.4342V2.56607C4.50004 1.9782 4.02184 1.5 3.43397 1.5ZM3.50004 13.4343C3.50004 13.4707 3.47044 13.5 3.43397 13.5H1.89944C1.86297 13.5 1.83337 13.4707 1.83337 13.4343V2.56607C1.83337 2.5296 1.86297 2.5 1.89944 2.5H3.43397C3.47044 2.5 3.50004 2.5296 3.50004 2.56607V13.4343Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BooksIcon.displayName = 'BooksIcon';
